import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://pofhtqmbmtuztrafrwyz.supabase.co';
const supabaseKey = 'sb_publishable_pQis9RE-ruALhwHDQvM-Jg_Aj3VrNe8';

export const supabase = createClient(supabaseUrl, supabaseKey);